import React, { useState } from 'react'

export default function Item({notification, onRead, onShow, onDelete}) {
  const [showTrash, setShowTrash] = useState(false)
  const seen = notification.seen
  const styles = {}
  if (notification.issued_by == 'ios') {
    styles.backgroundColor = seen ? notification.company_color + '10' : notification.company_color
    styles.borderColor = seen ? '' : notification.company_color
  } else {
    styles.backgroundColor = seen ? '#fff' : '#428bca'
    styles.borderColor = seen ? '' : '#428bca'
  }

  const readMessage = () => {
    if (!seen) onRead(notification.id)
    if (notification.game_id) onShow(notification.game_id)
  }

  const deleteMessage = (event) => {
    event.stopPropagation()
    onDelete(notification.id)
  }

  return <li 
    className={'notification' + (seen ? '' : ' unseen') }
    onMouseEnter={() => setShowTrash(true)} 
    onMouseLeave={() => setShowTrash(false)}
    onClick={readMessage}
    style={styles}
  >
    <div className='message'>
      {showTrash && <div className='fa fa-trash delete-notification' onClick={deleteMessage}></div>}
      <a>{notification.message}</a>
    </div>
  </li>
}
